import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonios() {
  const testimonios = [{
    initials: 'MP',
    name: 'Martín P.',
    location: 'Buenos Aires 🇦🇷',
    quote: 'Compré un viernes. El sábado a la noche tenía todo el mes de sesiones listo. Nunca más improviso antes del entreno.'
  }, {
    initials: 'CG',
    name: 'Carolina G.',
    location: 'Córdoba 🇦🇷',
    quote: 'Mis minis de 6 años que estaban perdidos en el espacio mejoraron su conducción desde la primera semana con el Tomo 1.'
  }, {
    initials: 'FR',
    name: 'Federico R.',
    location: 'Rosario 🇦🇷',
    quote: 'Antes tardaba 1 hora armando una sesión. Ahora son 5 minutos y el ejercicio ya está con variantes incluidas.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Mendoza 🇦🇷',
    quote: 'El Bonus de Frases del Profe cambió cómo corrijo en la cancha. Ahora sé exactamente qué decir y cuándo.'
  }, {
    initials: 'DA',
    name: 'Diego A.',
    location: 'Santa Fe 🇦🇷',
    quote: 'El Manual del DT me salvó con un padre que me quería comer después de un partido. Supe exactamente qué responder.'
  }, {
    initials: 'CR',
    name: 'Claudia R.',
    location: 'Tucumán 🇦🇷',
    quote: 'Las 100 variantes cambiaron mis entrenamientos. Los chicos ahora me piden más. Antes se aburrían al minuto 20.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-303">
      <div className="max-w-content mx-auto" data-id="element-304">
        <div className="text-center mb-16" data-id="element-305">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-306">
            Lo que dicen los profes
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex items-center justify-center gap-2 text-2xl font-black text-gray-900" data-id="element-307">
            4.9/5 <Star className="w-6 h-6 text-f360-gold fill-current" data-id="element-308" />
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-309">
          {testimonios.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.1
        }} className="bg-gray-50 p-8 rounded-2xl border border-gray-200 flex flex-col" data-id="element-310">
              <div className="flex items-center gap-4 mb-6" data-id="element-311">
                <div className="w-12 h-12 bg-f360-green text-white rounded-full flex items-center justify-center font-bold text-lg" data-id="element-312">
                  {t.initials}
                </div>
                <div data-id="element-313">
                  <h4 className="font-bold text-gray-900" data-id="element-314">{t.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-315">{t.location}</p>
                </div>
              </div>
              <div className="flex text-f360-gold mb-4" data-id="element-316">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-317" />)}
              </div>
              <p className="text-gray-700 italic text-lg leading-relaxed flex-grow" data-id="element-318">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}